import { theme } from 'antd';
import { groupPermissionsByEntityForGroup } from 'library/helpers/accessControl';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectPeople } from 'reduxStore/people/selectors';
import { selectPermissionsByGroupID } from 'reduxStore/permissions/selectors';
import { selectTeams } from 'reduxStore/teams/selectors';
import { Loader } from 'zComponents/atoms';
import { Empty, Flex, Tag, Typography } from 'zui/Antd';

const { Text } = Typography;

const PermissionPanelContent = ({ groupID }) => {
	const {
		token: { fontWeightStrong, paddingSM, paddingXXS }
	} = theme.useToken();

	// ✅ Redux selectors for hydration
	const permissions = useSelector((state) => selectPermissionsByGroupID(state, groupID));
	const people = useSelector(selectPeople);
	const teams = useSelector(selectTeams);
	const { loadingAddPermission, loadingDeletePermission } = useSelector((state) => state.Permissions);

	// ✅ Process permissions using the Source Distinction pattern
	const displayPermissions = useMemo(() => {
		return groupPermissionsByEntityForGroup({
			permissions,
			people,
			teams
		});
	}, [permissions, people, teams]);

	// Handle Loading State
	if (loadingAddPermission || loadingDeletePermission) {
		return (
			<Flex vertical align='center' gap={paddingSM} style={{ width: '100%', padding: paddingSM }}>
				<Loader />
				<Text type='secondary' style={{ fontSize: 12, textAlign: 'center' }}>
					Propagating permissions to devices — this may take a moment.
					<br />
					We'll notify you when it's done.
				</Text>
			</Flex>
		);
	}

	// Handle Empty State
	if (displayPermissions.length === 0) {
		return (
			<Flex justify='center' align='start' style={{ width: '100%' }}>
				<Empty description='No access permissions' image={Empty.PRESENTED_IMAGE_SIMPLE} />
			</Flex>
		);
	}

	return (
		<Flex wrap gap={paddingSM} style={{ width: '100%' }}>
			{displayPermissions.map((item) => (
				<Tag
					key={`${item.type}-${item.entityID}-${item.permissionID}`}
					color={item.badgeColor}
					style={{
						fontWeight: fontWeightStrong,
						borderColor: 'currentColor',
						marginInlineEnd: 0
					}}
				>
					<Flex align='center' gap={paddingXXS}>
						{item.Icon && <item.Icon color='currentColor' />}
						{item.label}
					</Flex>
				</Tag>
			))}
		</Flex>
	);
};

export default PermissionPanelContent;
